export default __webpack_public_path__ + "static/media/Coming soon.73d99502.jpg";